<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">お知らせ編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="27.3" height="27.3" />
      <p class="title-bk">お知らせ登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'notification' }">戻る</router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row" width="25%">掲載開始日</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top form-select-row">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.startDateObject.year"
                      placeholder="選択してください"
                      class="form-control select-year"
                      :class="classes"
                      :clearable="false"
                      :options="years"
                    />
                    <span class="select-text">年</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.startDateObject.month"
                      placeholder="選択してください"
                      class="form-control select-month"
                      :class="classes"
                      :clearable="false"
                      :options="months"
                    />
                    <span class="select-text">月</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.startDateObject.day"
                      placeholder="選択してください"
                      class="form-control select-day"
                      :class="classes"
                      :clearable="false"
                      :options="daysForStartDate"
                      :resetOnOptionsChange="true"
                    />
                    <span class="select-text">日</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th scope="row" width="25%">掲載終了日</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top form-select-row">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.endDateObject.year"
                      placeholder="選択してください"
                      class="form-control select-year"
                      :class="classes"
                      :clearable="false"
                      :options="years"
                    />
                    <span class="select-text">年</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.endDateObject.month"
                      placeholder="選択してください"
                      class="form-control select-month"
                      :class="classes"
                      :clearable="false"
                      :options="months"
                    />
                    <span class="select-text">月</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentNotification.endDateObject.day"
                      placeholder="選択してください"
                      class="form-control select-day"
                      :class="classes"
                      :clearable="false"
                      :options="daysForEndDate"
                    />
                    <span class="select-text">日</span>
                    <div class="invalid-feedback-area">
                      <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                    </div>
                  </ValidationProvider>
                </td>
              </tr>
              <TextField v-model="currentNotification.title" label="タイトル" extraRules="required" />
              <tr>
                <th scope="row">内容</th>
                <td>
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline brandname">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ invalid, errors }"
                  >
                    <vue-editor v-model="currentNotification.message" class="text-editor" />
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <th scope="row">重要アイコン</th>
                <td />
                <td class="form-inline brandname">
                  <input
                    type="radio"
                    class="body-radio"
                    id="important"
                    :value="null"
                    v-model="currentNotification.importance"
                  />
                  <label class="body-radio" for="important">重要アイコンをつけない</label>
                  <input
                    type="radio"
                    class="body-radio body-radio-right"
                    id="not_important"
                    :value="true"
                    v-model="currentNotification.importance"
                  />
                  <label class="body-radio" for="not_important">重要アイコンをつける</label>
                </td>
              </tr>
              <SelectField
                label="カテゴリ"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="notification.categoryOptions"
                v-model="currentNotification.category"
              />
              <SelectField
                label="表示先"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="notification.recipientOptions"
                optionValue="id"
                optionLabel="name"
                v-model="currentNotification.recipientIds"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">登録</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '@/store/index.js';
import { lastDateFromMonth } from '@/utils/date_helpers.js';
import { yearsTo, monthsOfYear, daysOfMonth } from '@/utils/year_helpers';
import { VueEditor } from 'vue2-editor';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    VueEditor,
    TextField,
    SelectField,
  },
  data() {
    return {
      currentNotification: {},
    };
  },
  created() {
    if (this.id) {
      this.currentNotification = this.notification.notification;
    } else {
      this.currentNotification = this.createFreshNotificationObject();
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('notification/fetchNotification', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  computed: {
    years() {
      return yearsTo(10);
    },
    months() {
      return monthsOfYear();
    },
    daysForStartDate() {
      // TODO: Re-calculate days of month after select year and month
      // 31 days
      return daysOfMonth(1, 2020);
    },
    daysForEndDate() {
      // TODO: Re-calculate days of month after select year and month
      // 31 days
      return daysOfMonth(1, 2020);
    },
    managementRecipient() {
      return ['management'];
    },
    teacherRecipient() {
      return ['teacher'];
    },
    studentRecipient() {
      return ['student'];
    },
    ...mapState(['notification']),
  },
  methods: {
    maxDate(year, month) {
      return lastDateFromMonth(year, month);
    },
    updateStartYearMonth() {
      const maxDate = this.maxDate(
        this.currentNotification.startDateObject.year,
        this.currentNotification.startDateObject.month
      );
      if (this.currentNotification.startDateObject.day > maxDate) {
        this.$logger.debug(
          'maxDate is ' + maxDate + ' only but current date is higher, so need to change current date'
        );
        this.currentNotification.startDateObject.day = maxDate;
      }
    },
    updateEndYearMonth() {
      const maxDate = this.maxDate(
        this.currentNotification.endDateObject.year,
        this.currentNotification.endDateObject.month
      );
      if (this.currentNotification.endDateObject.day > maxDate) {
        this.$logger.debug(
          'maxDate is ' + maxDate + ' only but current date is higher, so need to change current date'
        );
        this.currentNotification.endDateObject.day = maxDate;
      }
    },
    createFreshNotificationObject() {
      return {
        startDatetime: null,
        startDateObject: {
          year: null,
          month: null,
          day: null,
        },
        endDatetime: null,
        endDateObject: {
          year: null,
          month: null,
          day: null,
        },
        title: '',
        message: '',
        importance: null,
        category: null,
        recipientIds: null,
      };
    },
    submitForm() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentNotification));
      this.finishEditingNotification(this.currentNotification).then(() => {
        this.$router.push({ name: 'notification' });
      });
    },
    ...mapActions('notification', ['finishEditingNotification']),
  },
};
</script>

<style lang="scss" scoped>
.btn-confirm {
  margin-left: 0px;
}
.body-radio {
  margin-right: 5px;
}
.body-radio-right {
  margin-left: 20px;
}
.text-editor {
  max-width: 67%;
}

/deep/ .v-select-birth {
  .select-year,
  .select-month,
  .select-day {
    padding: 0px 2px 0px 10px;
    max-width: initial;
    margin-right: 5px;
    .vs__dropdown-toggle {
      width: 146px;
    }
  }
  .select-text {
    margin-right: 15px;
  }
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
  width: 200px;
}
</style>
